import React, { useContext } from "react";
import ColorsMain from "../../../colors/ColorsMain";
import "../../../css/login/login.css";
import { GLOBAL_LANGUAGE } from "../../../language/language";
import { UtilContext } from "../../../context/UtilContext"; // Asegúrate de importar el contexto correcto
import ButtonWhite from "../../button/ButtonWhite";
import ButtonBack from "../../button/ButtonBack";
import InputLogin from "../../inputs/InputLogin";


const RequestPassword = ({ email, setEmail, LoginRequest, errorMesagge = false, errorInput, onClickBack, loading }) => {
  const { language } = useContext(UtilContext); // Usa el contexto de Auth

  return (
    <div
      style={{ color: ColorsMain.texttMain }}
      className="w-3/4 flex justify-evenly flex-col"
    >
      <div className="flex flex-col">
        <p className="text-3xl" style={{ fontFamily: "brico" }}>
          {GLOBAL_LANGUAGE[language].request_password.title}
        </p>
        <p className="text-[#E4E4E4] flex mb-8 mt-2 text-[14px]">
          {GLOBAL_LANGUAGE[language].request_password.subtitle}
        </p>
        <p style={{ color: ColorsMain.textSecundary }} className="mb-1">
          {GLOBAL_LANGUAGE[language].request_password.label_email}
        </p>
        <InputLogin
          error={errorInput}
          value={email}
          onChange={(e) => setEmail(e)}
          label={GLOBAL_LANGUAGE[language].login.label_email}
          placeholder={GLOBAL_LANGUAGE[language].request_password.placeholder_email}
        />
        {errorMesagge && (
          <div className="w-full flex flex-col mt-1">
            <p className="text-[#FF928B] text-[14px]">{errorMesagge}</p>
          </div>
        )}

        <div className="flex flex-col md:flex-row md:justify-between mt-4 gap-2 md:gap-4 md:mt-8">
          <div className="order-2 md:order-1 w-full md:w-auto">
            <ButtonBack
              className="w-full mt-2 md:mt-0"
              onClick={onClickBack}
              label={GLOBAL_LANGUAGE[language].request_password.button_back}
            />
          </div>
          <div className="order-1 md:order-2 w-full md:w-auto">
            <ButtonWhite
              className="w-full mt-4 md:mt-0"
              loading={loading}
              onClick={() => LoginRequest()}
              label={GLOBAL_LANGUAGE[language].request_password.button_confirm}
            />
          </div>
        </div>

      </div>
    </div>
  );
};

export default RequestPassword;
